import type { BulkMaterialFormData } from '#components/order/CreateOrderDialog/OrderFormValidation.ts';

import { BULK_UNIT_MAP } from './constants.ts';

export const parseBulkMaterial = ({
    unitRaw,
    quantity,
    name,
}: {
    unitRaw: string | undefined;
    quantity: number;
    name: string;
}): BulkMaterialFormData | undefined => {
    if (!unitRaw || !(unitRaw in BULK_UNIT_MAP)) {
        return undefined;
    }

    return {
        type: 'bulk-material',
        packageType: 'bulk-material',
        name,
        quantity,
        unitType: BULK_UNIT_MAP[unitRaw],
    };
};
